import PropTypes from 'prop-types';
import {
  FormField,
  PhoneInputField,
} from '@codev/helix-react';
import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import reactStringReplace from 'react-string-replace';
import languagesPropType from '../languagesPropType.js';
import translate from './translate.js';
import styles from './styles.css';

const PhoneConfirmationForm = ({
  language,
  lastTwoDigits,
  onChange,
  phoneNumber,
}) => (
  <Grid
    className={styles.grid}
    fluid
  >
    <Row style={{textAlign: 'center'}}>
      <Col xs={12}>
        <span style={{fontSize: '18px'}}>{translate('verifyMobilePhone', language)}</span>
      </Col>
    </Row>

    <Row style={{marginTop: '20px', textAlign: 'center'}}>
      <Col xs={12}>
        <div style={{fontSize: '16px', fontWeight: 400}}>
          {reactStringReplace(translate('providePhoneNumber', language), '[lastTwoDigits]', (match, i) => <strong key={i}>{lastTwoDigits}</strong>)}
        </div>
      </Col>
    </Row>

    <Row style={{marginTop: '20px'}}>
      <Col xs={12}>
        <FormField
          isRequired
          isRequiredErrorMessage={translate('phoneNumberRequiredMessage', language)}
          label={translate('phoneNumber', language)}
          style={{marginLeft: 'auto', marginRight: 'auto', width: '320px'}}
          value={phoneNumber}
        >
          <PhoneInputField
            autoFocus
            onChange={onChange}
            value={phoneNumber}
          />
          <div className={styles.note}>
            {translate('textRatesApply', language)}
          </div>
        </FormField>
      </Col>
    </Row>
  </Grid>
);

PhoneConfirmationForm.defaultProps = {
  language: languagesPropType.defaultProp,
};

PhoneConfirmationForm.propTypes = {
  language: languagesPropType.propType,
  lastTwoDigits: PropTypes.string,
  onChange: PropTypes.func,
  phoneNumber: PropTypes.string,
};

export default PhoneConfirmationForm;
